import React from 'react'
import CustomMenu from "../CustomMenu/index";

const menus = [
  // {
  //   title: '首页',
  //   icon: 'home',
  //   key: '/home'
  // },
  {
    title: '资金管理',
    icon: 'laptop',
    key: '/home/record',
    subs: [
      {key: '/home/record/recharge', title: '充币记录', icon: '',},
      {key: '/home/record/withdraw', title: '提币管理', icon: '',},
      // {key: '/home/record/change', title: '资金动向详情', icon: '',},
    ]
  },
  {
    title: '订单管理',
    icon: 'laptop',
    key: '/home/order',
    subs: [
      {key: '/home/order/future', title: '合约交易订单管理', icon: '',},
      // {key: '/home/order/mining', title: '挖矿活动订单管理', icon: '',},
      // {key: '/home/order/change', title: '资产变动列表', icon: '',},
    ]
  },
  // {
  //   title: '产品管理',
  //   icon: 'laptop',
  //   key: '/home/product',
  //   subs: [
  //     {key: '/home/product/coin', title: '产品价格管理', icon: '',},
  //     {key: '/home/product/mining', title: '挖矿活动管理', icon: '',},
  //     {key: '/home/product/close', title: '产品合约平仓', icon: '',},
  //   ]
  // },
  {
    title: '量化管理',
    icon: 'laptop',
    key: '/home/lianghua',
    subs: [
      // {key: '/home/lianghua/list', title: '量化项目', icon: '',},
      // {key: '/home/lianghuaPlatform/list', title: '量化平台', icon: '',},
      {key: '/home/lianghuaTrade/list', title: '量化交易', icon: '',},
      // {key: '/home/lianghuaSecret/list', title: '量化密钥', icon: '',},
    ]
  },
  {
    title: '用户管理',
    icon: 'laptop',
    key: '/home/user',
    subs: [
      {key: '/home/user/list', title: '用户列表', icon: '',},
      {key: '/home/user/listCount', title: '用户统计', icon: '',},
      {key: '/home/user/auditList', title: '用户审核列表', icon: '',},
    ]
  },

]


class SiderNav extends React.Component {
  render() {

    return (
      <div style={{height: '100vh',overflowY:'scroll'}}>
        <div style={styles.logo}></div>
        <CustomMenu menus={menus}/>
      </div>
    )
  }
}

const styles = {
  logo: {
    height: '32px',
    background: 'rgba(255, 255, 255, .2)',
    margin: '16px'
  }
}

export default SiderNav



// WEBPACK FOOTER //
// ./src/components/SiderNav/index.js